import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { useIsMobile } from "@/hooks/use-mobile";
import { DesktopProspecting } from "./-components/desktop-prospecting";
import { MobileProspecting } from "./-components/mobile-prospecting";
import { NewSourceDialogs } from "./-components/new-source-dialogs";
import { useProspecting } from "./-components/use-prospecting";

export const Route = createFileRoute("/_authenticated/_crm/crm/prospecting/")({
  validateSearch: (search: Record<string, unknown>): { view?: "map" | "list" } => ({
    view: search.view === "list" ? "list" : search.view === "map" ? "map" : undefined,
  }),
  component: Prospecting,
});

/** The referral sources as a map and a list, around wherever the reader is standing. */
function Prospecting() {
  const search = Route.useSearch();
  const model = useProspecting(search.view ?? "map");
  const mobile = useIsMobile();
  const [adding, setAdding] = useState(false);
  const [importing, setImporting] = useState(false);
  const Layout = mobile ? MobileProspecting : DesktopProspecting;
  return (
    <>
      <Layout model={model} onAdd={() => setAdding(true)} onImport={() => setImporting(true)} />
      <NewSourceDialogs
        facilityId={model.facilityId}
        adding={adding}
        importing={importing}
        onCloseAdd={() => setAdding(false)}
        onCloseImport={() => setImporting(false)}
        onOpen={model.open}
      />
    </>
  );
}
